<!-- @prettier -->
<template>
	<div class="actions-collapsed-list">
		<button
			class="btn btn-function exit-collapsed-list"
			@click="collapseActions"
		>
			<i
				v-tooltip.right.hover="$t('CANCEL')"
				class="glyphicon glyphicon-chevron-left"
				aria-hidden="true"
			/>
		</button>

		<!-- Edit action -->
		<div v-if="createAccess" class="action-icon">
			<a class="btn btn-list-function" @click="showForm" :href="href">
				<i
					v-tooltip.right.hover="$t('PING_TREES_ACTIONS_EDIT')"
					class="typcn typcn-edit"
					aria-hidden="true"
				/>
				<span v-t="'PING_TREES_ACTIONS_EDIT'" class="hint-text-mobile" />
			</a>
		</div>

		<!-- pause action -->
		<div v-if="currentRingTree.enabled" class="action-icon">
			<button
				class="btn btn-list-function"
				@click="setStatus(false)"
				:disabled="disabled"
			>
				<i
					v-tooltip.right.hover="$t('PING_TREES_ENABLED_TRUE')"
					class="typcn typcn-media-pause"
				>
				</i>

				<span class="hint-text-mobile" v-t="'PING_TREES_ENABLED_TRUE'"> </span>
			</button>
		</div>

		<!-- set status action -->
		<div v-if="!currentRingTree.enabled" class="action-icon">
			<button
				class="btn btn-list-function"
				@click="setStatus(true)"
				:disabled="disabled"
			>
				<i
					v-tooltip.right.hover="$t('PING_TREES_ENABLED_FALSE')"
					class="typcn typcn-media-play"
				>
				</i>

				<span class="hint-text-mobile" v-t="'PING_TREES_ENABLED_FALSE'"> </span>
			</button>
		</div>

		<!-- Delete action -->
		<div v-if="isAdmin" class="action-icon">
			<button
				@click="confirmDelete"
				:disabled="disabled"
				class="btn btn-list-function"
			>
				<i
					class="typcn typcn-trash"
					v-tooltip.right.hover="$t('PING_TREES_ACTIONS_DELETE')"
					aria-hidden="true"
				></i>
				<span class="hint-text-mobile" v-t="'PING_TREES_ACTIONS_DELETE'">
				</span>
			</button>
		</div>
		<ChangeLogObjectButtonAction
			:disabled="disabled"
			:object-id="currentRingTree.id"
			:object-name="currentRingTree.name"
			object-type="tree"
		/>
	</div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import messages from '../locales';
import sharedMessages from '@/core/locales';

export default {
	name: 'RingTreeActions',
	components: {
		ChangeLogObjectButtonAction
	},
	props: {
		createAccess: {
			type: Boolean,
			default: false
		},
		currentRingTree: {
			type: Object,
			required: true
		},
		isAdmin: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		href: {
			type: String,
			default: ''
		}
	},
	methods: {
		confirmDelete() {
			if (!this.disabled) {
				this.$emit('confirm-delete', this.currentRingTree);
			}
		},
		setStatus(status) {
			if (!this.disabled) {
				this.$emit('set-status', this.currentRingTree, status);
			}
		},
		showForm(e) {
			e.preventDefault();

			this.$emit('show-edit-form', this.currentRingTree);
		},
		collapseActions() {
			this.$emit('collapse-actions', this.currentRingTree);
		}
	},
	i18n: {
		messages,
		sharedMessages,
		locale: 'en'
	}
};
</script>

<style lang="scss"></style>
